import { red } from '@material-ui/core/colors';

const groupFinanceiroTheme = {
  default: {
    palette: {
      type: 'light',
      primary: {
        main: '#3DA4BC',
        contrastText: '#FFF',
      },
      secondary: {
        light: '#FFFCFC',
        main: '#E6E3E3',
        dark: '#233d4d',
        contrastText: '#233d4d',
      },
      background: {
        paper: '#FFFFFF',
        default: '#F7F7F7',
      },
      error: red,
    },
    status: {
      danger: 'orange',
    },
  },
};

export default groupFinanceiroTheme;
